import { apiClient } from './apiClient';

// Local dev mounts api-keys at /api/api-keys, but many callers expect /api/users/apikeys.
// We'll support the canonical path used in serverless: /api/users/apikeys
const base = '/api/users/apikeys';

export const apiKeysService = {
  list: () => apiClient.get(base),
  get: provider => apiClient.get(`${base}/${encodeURIComponent(provider)}`),
  save: ({ provider, key, region, enabled }) =>
    apiClient.post(base, { provider, key, region, enabled }),
  remove: provider => apiClient.del(`${base}/${encodeURIComponent(provider)}`),
  test: provider => apiClient.post(`${base}/${encodeURIComponent(provider)}/test`, {}),
};

export default apiKeysService;
